interface Product {
  title: string;
  desc: string;
  price: string;
}

interface ServiceCardsProps {
  products: Product[];
}

export default function ServiceCards({ products = [] }: ServiceCardsProps) {
  if (products.length === 0) {
    return null;
  }

  return (
    <div className="pt-8">
      <h2 className="text-lg font-bold text-[#121B35] mb-4">구성 안내</h2>

      <div className="space-y-3 lg:grid lg:grid-cols-3 lg:gap-4 lg:space-y-0">
        {products.map((product, index) => (
          <div
            key={`${product.title}-${index}`}
            className="bg-white rounded-2xl p-4 border border-[#E8E2DA] flex items-center justify-between lg:flex-col lg:items-start lg:gap-3"
          >
            <div>
              <h3 className="text-[13px] font-semibold text-[#121B35]">
                {product.title}
              </h3>
              <p className="text-[11px] text-[#536079] mt-0.5">
                {product.desc}
              </p>
            </div>

            <span className="text-[13px] font-bold text-[#121B35] whitespace-nowrap lg:text-[15px]">
              {product.price}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}